import React from 'react';
import { CalendarPlus, Users, BookOpen, Heart } from 'lucide-react';
import StatCard from './StatCard';

const OverviewTab = ({ stats, onTabChange }) => {
  if (!stats) return null;

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
        <StatCard 
          icon={<CalendarPlus className="w-6 h-6" />} 
          title="Active Events" 
          value={stats.events || 0} 
          subtitle="upcoming" 
          onClick={() => onTabChange('events')} 
          color="purple" 
        />
        <StatCard 
          icon={<Users className="w-6 h-6" />} 
          title="Volunteers" 
          value={stats.volunteer_database?.active || 0} 
          subtitle={`${stats.volunteer_database?.total || 0} total`} 
          onClick={() => onTabChange('volunteer-db')} 
          color="green" 
        />
        <StatCard 
          icon={<BookOpen className="w-6 h-6" />} 
          title="Madrassah" 
          value={stats.madrassah_students?.active || 0} 
          subtitle="students" 
          onClick={() => onTabChange('madrassah')} 
          color="blue" 
        />
        <StatCard 
          icon={<Heart className="w-6 h-6" />} 
          title="Donations" 
          value={stats.donations?.total || 0} 
          subtitle={`$${stats.donations?.total_amount?.toFixed(2) || '0.00'}`} 
          onClick={() => onTabChange('donations')} 
        />
      </div>
      <div className="bg-white p-6 shadow-lg">
        <h2 className="text-xl text-[#1a2f23] mb-4">Quick Info</h2>
        <div className="text-sm text-[#5a6d62] space-y-2">
          <p><strong>Email:</strong> fatimiacss@gmail.com</p>
          <p><strong>E-Transfer:</strong> donation@fatimia.ca</p>
          <p><strong>Unread Messages:</strong> {stats.contacts?.unread || 0}</p>
        </div>
      </div>
    </>
  );
};

export default OverviewTab;
